import React, { useContext, useState, useEffect } from "react";
import { TranslatorContext } from "../../context/Translator";
import { ButtonComponent, AnchorComponent } from "../../components/elements";
import IconFieldComponent from "../../components/fields/IconFieldComponent";
import LogoComponent from "../../components/LogoComponent";
import { useNavigate } from "react-router-dom";
import axios from "axios";
import { BASE_URL, TOKEN, CURRENT_IP } from "../../helper/BASE_URL";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import EnterOtpLogin from "./EnterOtpLogin";
import { IoMdMail } from "react-icons/io";
import { IconUser } from "react-icons/io";
import { IoPerson, IoPersonAdd, IoGlobeOutline } from "react-icons/io5";
import { MdAddIcCall } from "react-icons/md";
import { FaShareSquare } from "react-icons/fa";

export default function RegisterPage() {
  const [email, setEmail] = useState("");
  const [otp, setOtp] = useState("");
  const [openEnterOtp, setOpenEnterOtp] = useState(false);
  const [IsLoading, setIsLoading] = useState(false);
  const [enteredOtp, setEnteredOtp] = useState("");
  const [setshowOtp, setSetshowOtp] = useState(false);
  const [goFurtherMore, setGoFurtherMore] = useState(false);
  const [isChangable, setIsChangable] = useState(false);

  // for registertaion

  const [fname, setfName] = useState("");
  const [last_name, setLast_name] = useState("");
  const [emails, setEmails] = useState("");
  const [Country, setCountry] = useState("");
  const [CountryName, setCountryName] = useState("");
  const [contactNumber, setContactNumber] = useState("");
  const [setsponserCode, setSetsponserCode] = useState("");

  const navigate = useNavigate();

  const Handle_Register = (e) => {
    e.preventDefault();

    setIsLoading(true);

    console.log({
      reg_em: emails,
      ip_addr: window.localStorage.getItem("bpipos")
        ? window.localStorage.getItem("bpipos")
        : "224.234.50.218",
    });

    try {
      axios
        .post(
          BASE_URL + "send_register_otp.php",
          {
            reg_em: emails,
            ip_addr: window.localStorage.getItem("bpipos")
              ? window.localStorage.getItem("bpipos")
              : "224.234.50.218",
          },
          {
            headers: {
              ClientKey: TOKEN,
            },
          }
        )
        .then((acc) => {
          setIsLoading(false);

          if (acc.data.status == "FAILED") {
            toast.error(acc.data.message);
          } else {
            setOpenEnterOtp(true);
            toast.success(acc.data.message);
            setGoFurtherMore(true);
          }
        })
        .catch((err) => {
          setIsLoading(false);
        });
    } catch (error) {
      setIsLoading(false);
    }
  };

  const Countrys = [
    { name: "Afghanistan", code: 93 },
    { name: "Albania", code: 355 },
    { name: "Algeria", code: 213 },
    { name: "Andorra", code: 376 },
    { name: "Angola", code: 244 },
    { name: "Antigua and Barbuda", code: 1268 },
    { name: "Argentina", code: 54 },
    { name: "Armenia", code: 374 },
    { name: "Australia", code: 61 },
    { name: "Austria", code: 43 },
    { name: "Azerbaijan", code: 994 },
    { name: "Bahamas", code: 1242 },
    { name: "Bahrain", code: 973 },
    { name: "Bangladesh", code: 880 },
    { name: "Barbados", code: 1246 },
    { name: "Belarus", code: 375 },
    { name: "Belgium", code: 32 },
    { name: "Belize", code: 501 },
    { name: "Benin", code: 229 },
    { name: "Bhutan", code: 975 },
    { name: "Bolivia", code: 591 },
    { name: "Bosnia and Herzegovina", code: 387 },
    { name: "Botswana", code: 267 },
    { name: "Brazil", code: 55 },
    { name: "Brunei", code: 673 },
    { name: "Bulgaria", code: 359 },
    { name: "Burkina Faso", code: 226 },
    { name: "Burundi", code: 257 },
    { name: "Cabo Verde", code: 238 },
    { name: "Cambodia", code: 855 },
    { name: "Cameroon", code: 237 },
    { name: "Canada", code: 1 },
    { name: "Central African Republic", code: 236 },
    { name: "Chad", code: 235 },
    { name: "Chile", code: 56 },
    { name: "China", code: 86 },
    { name: "Colombia", code: 57 },
    { name: "Comoros", code: 269 },
    { name: "Congo (Congo-Brazzaville)", code: 242 },
    { name: "Congo (DRC)", code: 243 },
    { name: "Costa Rica", code: 506 },
    { name: "Croatia", code: 385 },
    { name: "Cuba", code: 53 },
    { name: "Cyprus", code: 357 },
    { name: "Czechia", code: 420 },
    { name: "Denmark", code: 45 },
    { name: "Djibouti", code: 253 },
    { name: "Dominica", code: 1767 },
    { name: "Dominican Republic", code: 1809 },
    { name: "Ecuador", code: 593 },
    { name: "Egypt", code: 20 },
    { name: "El Salvador", code: 503 },
    { name: "Equatorial Guinea", code: 240 },
    { name: "Eritrea", code: 291 },
    { name: "Estonia", code: 372 },
    { name: "Eswatini", code: 268 },
    { name: "Ethiopia", code: 251 },
    { name: "Fiji", code: 679 },
    { name: "Finland", code: 358 },
    { name: "France", code: 33 },
    { name: "Gabon", code: 241 },
    { name: "Gambia", code: 220 },
    { name: "Georgia", code: 995 },
    { name: "Germany", code: 49 },
    { name: "Ghana", code: 233 },
    { name: "Greece", code: 30 },
    { name: "Grenada", code: 1473 },
    { name: "Guatemala", code: 502 },
    { name: "Guinea", code: 224 },
    { name: "Guinea-Bissau", code: 245 },
    { name: "Guyana", code: 592 },
    { name: "Haiti", code: 509 },
    { name: "Honduras", code: 504 },
    { name: "Hungary", code: 36 },
    { name: "Iceland", code: 354 },
    { name: "India", code: 91 },
    { name: "Indonesia", code: 62 },
    { name: "Iran", code: 98 },
    { name: "Iraq", code: 964 },
    { name: "Ireland", code: 353 },
    { name: "Israel", code: 972 },
    { name: "Italy", code: 39 },
    { name: "Jamaica", code: 1876 },
    { name: "Japan", code: 81 },
    { name: "Jordan", code: 962 },
    { name: "Kazakhstan", code: 7 },
    { name: "Kenya", code: 254 },
    { name: "Kiribati", code: 686 },
    { name: "Korea (North)", code: 850 },
    { name: "Korea (South)", code: 82 },
    { name: "Kuwait", code: 965 },
    { name: "Kyrgyzstan", code: 996 },
    { name: "Laos", code: 856 },
    { name: "Latvia", code: 371 },
    { name: "Lebanon", code: 961 },
    { name: "Lesotho", code: 266 },
    { name: "Liberia", code: 231 },
    { name: "Libya", code: 218 },
    { name: "Liechtenstein", code: 423 },
    { name: "Lithuania", code: 370 },
    { name: "Luxembourg", code: 352 },
    { name: "Madagascar", code: 261 },
    { name: "Malawi", code: 265 },
    { name: "Malaysia", code: 60 },
    { name: "Maldives", code: 960 },
    { name: "Mali", code: 223 },
    { name: "Malta", code: 356 },
    { name: "Marshall Islands", code: 692 },
    { name: "Mauritania", code: 222 },
    { name: "Mauritius", code: 230 },
    { name: "Mexico", code: 52 },
    { name: "Micronesia", code: 691 },
    { name: "Moldova", code: 373 },
    { name: "Monaco", code: 377 },
    { name: "Mongolia", code: 976 },
    { name: "Montenegro", code: 382 },
    { name: "Morocco", code: 212 },
    { name: "Mozambique", code: 258 },
    { name: "Myanmar (Burma)", code: 95 },
    { name: "Namibia", code: 264 },
    { name: "Nauru", code: 674 },
    { name: "Nepal", code: 977 },
    { name: "Netherlands", code: 31 },
    { name: "New Zealand", code: 64 },
    { name: "Nicaragua", code: 505 },
    { name: "Niger", code: 227 },
    { name: "Nigeria", code: 234 },
    { name: "North Macedonia", code: 389 },
    { name: "Norway", code: 47 },
    { name: "Oman", code: 968 },
    { name: "Pakistan", code: 92 },
    { name: "Palau", code: 680 },
    { name: "Panama", code: 507 },
    { name: "Papua New Guinea", code: 675 },
    { name: "Paraguay", code: 595 },
    { name: "Peru", code: 51 },
    { name: "Philippines", code: 63 },
    { name: "Poland", code: 48 },
    { name: "Portugal", code: 351 },
    { name: "Qatar", code: 974 },
    { name: "Romania", code: 40 },
    { name: "Russia", code: 7 },
    { name: "Rwanda", code: 250 },
    { name: "Saint Kitts and Nevis", code: 1869 },
    { name: "Saint Lucia", code: 1758 },
    { name: "Saint Vincent and the Grenadines", code: 1784 },
    { name: "Samoa", code: 685 },
    { name: "San Marino", code: 378 },
    { name: "Sao Tome and Principe", code: 239 },
    { name: "Saudi Arabia", code: 966 },
    { name: "Senegal", code: 221 },
    { name: "Serbia", code: 381 },
    { name: "Seychelles", code: 248 },
    { name: "Sierra Leone", code: 232 },
    { name: "Singapore", code: 65 },
    { name: "Slovakia", code: 421 },
    { name: "Slovenia", code: 386 },
    { name: "Solomon Islands", code: 677 },
    { name: "Somalia", code: 252 },
    { name: "South Africa", code: 27 },
    { name: "South Sudan", code: 211 },
    { name: "Spain", code: 34 },
    { name: "Sri Lanka", code: 94 },
    { name: "Sudan", code: 249 },
    { name: "Suriname", code: 597 },
    { name: "Sweden", code: 46 },
    { name: "Switzerland", code: 41 },
    { name: "Syria", code: 963 },
    { name: "Taiwan", code: 886 },
    { name: "Tajikistan", code: 992 },
    { name: "Tanzania", code: 255 },
    { name: "Thailand", code: 66 },
    { name: "Timor-Leste", code: 670 },
    { name: "Togo", code: 228 },
    { name: "Tonga", code: 676 },
    { name: "Trinidad and Tobago", code: 1868 },
    { name: "Tunisia", code: 216 },
    { name: "Turkey", code: 90 },
    { name: "Turkmenistan", code: 993 },
    { name: "Tuvalu", code: 688 },
    { name: "Uganda", code: 256 },
    { name: "Ukraine", code: 380 },
    { name: "United Arab Emirates", code: 971 },
    { name: "United Kingdom", code: 44 },
    { name: "United States of America", code: 1 },
    { name: "Uruguay", code: 598 },
    { name: "Uzbekistan", code: 998 },
    { name: "Vanuatu", code: 678 },
    { name: "Vatican City", code: 379 },
    { name: "Venezuela", code: 58 },
    { name: "Vietnam", code: 84 },
    { name: "Yemen", code: 967 },
    { name: "Zambia", code: 260 },
    { name: "Zimbabwe", code: 263 },
  ];

  const Submit_OTP = (e) => {
    e.preventDefault();

    const Find_Country_Name = Countrys.find((e) => e.code == Country);

    setIsLoading(true);

    try {
      axios
        .post(
          BASE_URL + "register.php",
          {
            spon_token: setsponserCode,
            first_name: fname,
            last_name: last_name,
            ctry_name: Find_Country_Name.name,
            ctry_code: Country,
            reg_mob: contactNumber,
            otp: otp,
            reg_em: emails,
            ip_addr: window.localStorage.getItem("bpipos")
              ? window.localStorage.getItem("bpipos")
              : "224.234.50.218",
          },
          {
            headers: {
              ClientKey: TOKEN,
            },
          }
        )
        .then((acc) => {
          setIsLoading(false);

          if (acc.data.status == "FAILED") {
            toast.error(acc.data.message);
          } else {
            setOpenEnterOtp(true);
            toast.success("Registred Successfully");
            sessionStorage.removeItem("thirdweb:connected-wallet-idsasfrw");

            navigate("/welcome");
          }
        })
        .catch((err) => {
          setIsLoading(false);
        });
    } catch (error) {
      setIsLoading(false);
    }
  };

  useEffect(() => {
    const getData = sessionStorage.getItem("thirdweb:connected-wallet-idsasfrw");

    if (getData) {
      setSetsponserCode(getData);
    }
  }, []);

  const saveSTates = async (e) => {
    e.preventDefault();

    // const checkSponser  =async ()=> {

    //   try {
    //     axios
    //       .post(
    //         BASE_URL + "get_token_details.php",
    //         {
    //           token: setsponserCode,
    //           ip_addr: window.localStorage.getItem('bpipos')?window.localStorage.getItem('bpipos'):'224.234.50.218',

    //         },
    //         {
    //           headers: {
    //             ClientKey: TOKEN,
    //           },
    //         }
    //       )
    //       .then((acc) => {

    //         if (acc.data.status == "SUCCESS") {
    //           return true
    //         }else{
    //           return false

    //         }

    //       })
    //       .catch((err) => {

    //         return false
    //       });
    //   } catch (error) {

    //     return false
    //   }

    // }

    // const checkEmail=async()=> {
    //   try {
    //     axios
    //       .post(
    //         BASE_URL + "verify_email_exist.php",
    //         {
    //           reg_em: emails,
    //           ip_addr: window.localStorage.getItem('bpipos')?window.localStorage.getItem('bpipos'):'224.234.50.218',
    //         },
    //         {
    //           headers: {
    //             ClientKey: TOKEN,
    //           },
    //         }
    //       )
    //       .then((acc) => {

    //         if (acc.data.status == "SUCCESS") {
    //           return true
    //         }else{
    //           return false

    //         }

    //       })
    //       .catch((err) => {
    //         return false

    //       });
    //   } catch (error) {
    //     return false

    //   }
    // }

    // let func1 = await cfheckEmail()
    // let func2 = await checkSponser()

    // if (func1 == true && func2 == true) {
    // setSetshowOtp(true)
    // }else{
    //   toast.error("Please Check Your Credentials")
    // }

    setIsLoading(true);

    const checkSponser = async () => {
      try {
        const acc = await axios.post(
          BASE_URL + "get_token_details.php",
          {
            token: setsponserCode,
            ip_addr: window.localStorage.getItem("bpipos")
              ? window.localStorage.getItem("bpipos")
              : "224.234.50.218",
          },
          {
            headers: {
              ClientKey: TOKEN,
            },
          }
        );

        if (acc.data.status === "SUCCESS") {
          return true;
        } else {
          return false;
        }
      } catch (error) {
        setIsLoading(false);
        return false;
      }
    };

    const checkEmail = async () => {
      try {
        const acc = await axios.post(
          BASE_URL + "verify_email_exist.php",
          {
            reg_em: emails,
            ip_addr: window.localStorage.getItem("bpipos")
              ? window.localStorage.getItem("bpipos")
              : "224.234.50.218",
          },
          {
            headers: {
              ClientKey: TOKEN,
            },
          }
        );

        console.log(acc.data);

        if (acc.data.status === "SUCCESS") {
          return true;
        } else {
          return false;
        }
      } catch (error) {
        setIsLoading(false);

        return false;
      }
    };

    const handleValidation = async () => {
      let func1 = await checkEmail();
      let func2 = await checkSponser();

      console.log(func1);
      console.log(func2);

      if (func1 && func2) {
        setIsLoading(false);
        setSetshowOtp(true);
      } else {
        setIsLoading(false);
        toast.error("Please Check Your Credentials");
      }
    };

    let datss = handleValidation();

    console.log("sdgsdg");
    console.log(datss);
  };

  const handleGoBack = () => {
    setSetshowOtp(false);
  };

  const GoAbsoluteBack = () => {
    setSetshowOtp(false);
    setGoFurtherMore(false);
    setOtp("");
  };

  return (
    <div className="d-flex justify-content-center align-items-center vh-100 bg-light">
      <ToastContainer />
      <div
        className="position-relative w-100 h-100 overflow-hidden shadow-md"
        style={{
          backgroundImage:
            "linear-gradient(rgb(255, 193, 7) 0%, rgb(222 159 64) 100%)",
        }}
      >
        {/* Background images */}
        <img
          className="position-absolute top-0 d-none d-md-block"
          style={{ transform: "scale(1.05)", maxWidth: "100%", height: "auto" }}
          src="/login_background.PNG"
          alt="Background"
        />
        <img
          className="position-absolute bottom-0 d-block d-md-none"
          style={{ transform: "scale(1.05)", maxWidth: "100%", height: "120%" }}
          src="/login_background_vertical.PNG"
          alt="Background"
        />

        {/* Overlay */}
        <div className="position-absolute w-100 h-100 bg-transparent"></div>

        <div className="d-flex align-items-center justify-content-center vh-100 bg-cover bg-center bg-no-repeat overflow-y-auto position-relative">
          <div className="w-100 rounded position-relative">
            <div className="d-flex flex-column justify-content-center rounded position-relative">
              <div className="d-flex flex-column flex-md-row w-100 justify-content-evenly mx-auto py-4 gap-2 vh-100">
                {/* Left Section */}
                <div className="d-none d-md-flex flex-column justify-content-evenly px-4 w-100">
                  <div>
                    <h3 className="text-center text-uppercase text-black">
                      Welcome to
                    </h3>
                    <h1 className="text-center text-uppercase font-weight-bold text-black">
                      BOSS PANDA
                    </h1>
                  </div>
                  <div className="d-flex flex-column align-items-center">
                    <img
                      src="/logo.png"
                      alt="bosspanda"
                      className="align-self-center mb-3"
                      width={230}
                      height={230}
                    />
                    <p
                      style={{ fontWeight: 800, fontSize: "large" }}
                      className="text-center font-weight-bold text-black"
                    >
                      Get set up in minutes!
                    </p>
                  </div>

                  <div className="d-flex flex flex-lg-column-reverse align-items-center justify-content-center gap-2 text-black">
                    <p
                      onClick={() => navigate("/login")}
                      style={{
                        fontWeight: 800,
                        fontSize: "large",
                        color: "blue",
                      }}
                      className=" cursor-pointer text-decoration-none"
                    >
                      Login
                    </p>
                    <p>Already have an account?</p>
                  </div>
                </div>

                {/* Mobile Image Section */}
                <div
                  style={{ alignItems: "center" }}
                  className="d-flex flex-column justify-content-center d-md-none mt-0 alif"
                >
                  <img
                    src="/logo.png"
                    alt="BossPanda"
                    width={150}
                    height={150}
                  />

                  <h5 style={{ marginTop: 10, color: "#514b4b" }}>
                    Welcome to Boss Panda
                  </h5>
                  <br></br>
                  <br></br>
                  <h3 style={{ color: "black" }}>Create Your Account</h3>
                </div>

                {setshowOtp ? (
                  goFurtherMore ? (
                    <>
                      <form className="d-flex flex-column justify-content-center w-100 px-4 px-md-5 text-black">
                        <p
                          className="position-static top-0 end-0 d-none w-100 text-center fs-1 fw-bold mb-md-10 d-md-block"
                          style={{ color: "black" }}
                        >
                          Enter OTP
                        </p>

                        <style jsx>{`
                          input::placeholder {
                            color: #383732;

                            font-weight: 500;
                          }

                          select {
                            color: #383732;
                            font-weight: 500 !important;
                            font-size: 15px;
                          }
                        `}</style>

                        {/* Email Input */}

                        <div className="position-relative mb-3">
                          <input
                            value={otp}
                            onChange={(e) => setOtp(e.target.value)}
                            style={{
                              fontWeight: "bold",
                              color: "black",
                              fontSize: "15px",
                            }}
                            type="text"
                            placeholder="Enter OTP"
                            className="bold-black-input bold-input w-100 ms-2 border-bottom border-dark text-black p-3 text-15 ps-4 fw-semibold placeholder-white-dark focus:outline-none"
                          />
                          <div className="position-absolute start-4 top-50 translate-middle-y">
                            <IoMdMail size={25} style={{ color: "#f0ba18" }} />
                          </div>
                        </div>
                        {/* <p onClick={GoAbsoluteBack} style={{ marginBottom: 20, marginTop: -15, color: "gray", cursor: "pointer" }}>Go Back</p> */}

                        {/* Submit Button */}

                        {IsLoading ? (
                          <ButtonComponent
                            disabled={IsLoading}
                            handleClick={() => {}}
                            className="mc-btn primary"
                            icon="arrow_forward"
                            text={"Proceed"}
                            style={{
                              background: "#f0ba18",
                              color: "black",
                            }}
                          />
                        ) : (
                          <ButtonComponent
                            disabled={IsLoading}
                            handleClick={Submit_OTP}
                            className="mc-btn primary"
                            icon="arrow_forward"
                            text={"Proceed"}
                            style={{
                              background: "#f0ba18",
                              color: "black",
                            }}
                          />
                        )}

                        {/* Mobile Sign-In/Forgot Password */}
                        <div className="d-flex justify-content-center gap-4 mt-1 d-md-none">
                          <p
                            className="cursor-pointer text-decoration-none"
                            onClick={() => navigate("/login")}
                          >
                            Already have an account? &nbsp;&nbsp;
                            <span style={{ color: "blue" }}>Login</span>
                          </p>
                        </div>
                        <p
                          style={{
                            textAlign: "center",
                            color: "black",
                            marginTop: 15,
                            fontWeight: 600,
                          }}
                        >
                          © BossPanda All Rights Reserved
                        </p>
                      </form>
                    </>
                  ) : (
                    <form className="d-flex flex-column justify-content-center w-100 px-4 px-md-5 text-black">
                      <p
                        className="position-static top-0 end-0 d-none w-100 text-center fs-1 fw-bold mb-md-10 d-md-block"
                        style={{ color: "black" }}
                      >
                        Confirm Your Email
                      </p>

                      <style jsx>{`
                        input::placeholder {
                          color: #383732;

                          font-weight: 500;
                        }

                        select {
                          color: #383732;
                          font-weight: 500 !important;
                          font-size: 15px;
                        }
                      `}</style>

                      {/* Email Input */}
                      <div className="position-relative mb-3">
                        <input
                          disabled={!isChangable}
                          onChange={(e) => setEmails(e.target.value)}
                          value={emails}
                          style={{
                            fontWeight: "bold",
                            color: "black",
                            fontSize: "15px",
                          }}
                          type="text"
                          placeholder="Confirm Your Email"
                          className="bold-black-input bold-input w-100 ms-2 border-bottom border-dark text-black p-3 text-15 ps-4 fw-semibold placeholder-white-dark focus:outline-none"
                        />
                        <div className="position-absolute start-4 top-50 translate-middle-y">
                          <IoMdMail size={25} style={{ color: "#f0ba18" }} />
                        </div>
                      </div>

                      <p
                        onClick={() => [setEmails(""), setIsChangable(true)]}
                        style={{
                          marginBottom: 20,
                          marginTop: -15,
                          color: "gray",
                          cursor: "pointer",
                        }}
                      >
                        Change Your Email
                      </p>

                      {/* Submit Button */}
                      {IsLoading ? (
                        <ButtonComponent
                          disabled={IsLoading}
                          handleClick={Handle_Register}
                          className="mc-btn primary"
                          icon="arrow_forward"
                          text={"Proceed"}
                          style={{
                            background: "#f0ba18",
                            color: "black",
                          }}
                        />
                      ) : (
                        <ButtonComponent
                          disabled={IsLoading}
                          handleClick={Handle_Register}
                          className="mc-btn primary"
                          icon="arrow_forward"
                          text={"Proceed"}
                          style={{
                            background: "#f0ba18",
                            color: "black",
                          }}
                        />
                      )}

                      {/* Mobile Sign-In/Forgot Password */}
                      <div className="d-flex justify-content-center gap-4 mt-1 d-md-none">
                        <p
                          className="cursor-pointer text-decoration-none"
                          onClick={() => navigate("/login")}
                        >
                          Already have an account? &nbsp;&nbsp;
                          <span style={{ color: "blue" }}>Login</span>
                        </p>
                      </div>
                      <p
                        style={{
                          textAlign: "center",
                          color: "black",
                          marginTop: 15,
                          fontWeight: 600,
                        }}
                      >
                        © BossPanda All Rights Reserved
                      </p>
                    </form>
                  )
                ) : (
                  <form className="d-flex flex-column justify-content-center w-100 px-4 px-md-5 text-black">
                    <p
                      className="position-static top-0 end-0 d-none w-100 text-center fs-1 fw-bold mb-md-10 d-md-block"
                      style={{ color: "black" }}
                    >
                      Create Your Account
                    </p>

                    {/* Name Input */}
                    <div className="position-relative mb-3">
                      <input
                        value={fname}
                        onChange={(e) => setfName(e.target.value)}
                        style={{
                          fontWeight: "bold",
                          color: "black",
                          fontSize: "15px",
                        }}
                        type="text"
                        placeholder="Enter First Name"
                        className="bold-black-input bold-input w-100 ms-2 border-bottom border-dark text-black p-3 text-15 ps-4 fw-semibold placeholder-white-dark focus:outline-none"
                      />
                      <div className="position-absolute start-4 top-50 translate-middle-y">
                        <IoPerson size={25} style={{ color: "#f0ba18" }} />
                      </div>
                    </div>

                    <style jsx>{`
                      input::placeholder {
                        color: #383732;

                        font-weight: 500;
                      }

                      select {
                        color: #383732;
                        font-weight: 500 !important;
                        font-size: 15px;
                      }
                    `}</style>

                    {/* Name Input */}
                    <div className="position-relative mb-3">
                      <input
                        value={last_name}
                        onChange={(e) => setLast_name(e.target.value)}
                        type="text"
                        placeholder="Enter Last Name"
                        className="bold-black-input bold-input w-100 ms-2 border-bottom border-dark text-black p-3 text-15 ps-4 fw-semibold placeholder-white-dark focus:outline-none"
                      />
                      <div className="position-absolute start-4 top-50 translate-middle-y">
                        <IoPersonAdd size={25} style={{ color: "#f0ba18" }} />
                      </div>
                    </div>

                    {/* Country Select */}
                    <div className="position-relative mb-3">
                      <select
                        value={Country}
                        onChange={(e) => setCountry(e.target.value)}
                        className="w-100 ps-4 ms-2 border-bottom border-dark p-3 text-15 placeholder-white-dark focus:outline-none "
                        defaultValue="Select Country"
                      >
                        {/* <option value="jj" disabled>
                          Select Country
                        </option> */}
                        <option value={null}>Select Country</option>

                        {Countrys.map((hit) => {
                          return <option value={hit.code}>{hit.name}</option>;
                        })}
                      </select>
                      <div className="position-absolute start-4 top-50 translate-middle-y">
                        <IoGlobeOutline
                          size={25}
                          style={{ color: "#f0ba18" }}
                        />
                      </div>
                    </div>

                    {/* Mobile Number Input */}
                    <div className="position-relative mb-3">
                      <input
                        value={contactNumber}
                        onChange={(e) => setContactNumber(e.target.value)}
                        type="number"
                        placeholder="Enter Mobile Number"
                        className="bold-black-input bold-input w-100 ms-2 border-bottom border-dark text-black p-3 text-15 ps-4 fw-semibold placeholder-white-dark focus:outline-none"
                      />
                      <div className="position-absolute start-4 top-50 translate-middle-y">
                        <MdAddIcCall size={25} style={{ color: "#f0ba18" }} />
                      </div>
                    </div>

                    {/* Referral Code Input */}
                    <div className="position-relative mb-3">
                      <input
                        value={setsponserCode}
                        onChange={(e) => setSetsponserCode(e.target.value)}
                        type="text"
                        placeholder="Enter Referral Code"
                        className="bold-black-input bold-input w-100 ms-2 border-bottom border-dark text-black p-3 text-15 ps-4 fw-semibold placeholder-white-dark focus:outline-none"
                      />
                      <div className="position-absolute start-4 top-50 translate-middle-y">
                        <FaShareSquare size={25} style={{ color: "#f0ba18" }} />
                      </div>
                    </div>

                    {/* Email Input */}
                    <div className="position-relative mb-3">
                      <input
                        value={emails}
                        onChange={(e) => setEmails(e.target.value)}
                        style={{
                          fontWeight: "bold",
                          color: "black",
                          fontSize: "15px",
                        }}
                        type="email"
                        placeholder="Enter Email"
                        className="bold-black-input bold-input w-100 ms-2 border-bottom border-dark text-black p-3 text-15 ps-4 fw-semibold placeholder-white-dark focus:outline-none"
                      />
                      <div className="position-absolute start-4 top-50 translate-middle-y">
                        <IoMdMail size={25} style={{ color: "#f0ba18" }} />
                      </div>
                    </div>

                    {/* Submit Button */}

                    {fname &&
                    last_name &&
                    Country &&
                    contactNumber &&
                    // contactNumber.length ==  &&
                    setsponserCode &&
                    emails ? (
                      <ButtonComponent
                        disabled={IsLoading}
                        handleClick={saveSTates}
                        className="mc-btn primary"
                        icon="arrow_forward"
                        text={"Proceed"}
                        style={{
                          background: "#f0ba18",
                          color: "black",
                        }}
                      />
                    ) : (
                      <ButtonComponent
                        disabled={true}
                        hasStopped={true}
                        handleClick={() => {}}
                        className="mc-btn primary"
                        icon="arrow_forward"
                        text={"Proceed"}
                        style={{
                          background: "#f0ba18",
                          color: "black",
                        }}
                      />
                    )}

                    {/* Mobile Sign-In/Forgot Password */}
                    <div className="d-flex justify-content-center gap-4 mt-1 d-md-none">
                      <p
                        className="cursor-pointer text-decoration-none"
                        onClick={() => navigate("/login")}
                      >
                        Already have an account? &nbsp;&nbsp;
                        <span style={{ color: "blue" }}>Login</span>
                      </p>
                    </div>
                    <p
                      style={{
                        textAlign: "center",
                        color: "black",
                        marginTop: 15,
                        fontWeight: 600,
                      }}
                    >
                      © BossPanda All Rights Reserved
                    </p>
                  </form>
                )}
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
